<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on:click="$emit('click')" v-bind="attrs" v-on="on">
        <v-icon color="grey lighten-1" :x-small="xSmall">
          {{ iconName }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'lean-list-item-button',
  props: {
    iconName: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    xSmall: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>
